var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8186 12.8087C19.1915 11.4405 18.5397 10.1608 17.8289 8.9032C18.5389 7.67046 19.1748 6.69272 19.7684 5.91978C19.8481 5.81619 19.8752 5.68231 19.8433 5.55561C19.8107 5.42971 19.723 5.32452 19.6035 5.27194C17.8201 4.48225 16.0662 4.86951 14.3706 5.24404C12.8837 5.57235 11.4757 5.87355 10.082 5.42095V13.6413C10.588 13.7776 11.0916 13.8318 11.5913 13.8318C12.5953 13.8318 13.5842 13.6126 14.5539 13.3991C16.1874 13.0373 17.7309 12.6978 19.2592 13.3736C19.421 13.4453 19.609 13.4086 19.7341 13.2835C19.8585 13.1584 19.8911 12.9688 19.8178 12.8078L19.8186 12.8087Z",
    fill: "#32589F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8492 9.27005L13.4556 8.8764C13.2269 8.64771 12.8555 8.64771 12.6268 8.8764C12.3981 9.1051 12.3981 9.47643 12.6268 9.70513L13.4795 10.5578C13.6835 10.7618 14.015 10.7618 14.219 10.5578L15.9003 8.8764C16.129 8.64771 16.129 8.27637 15.9003 8.04768C15.6716 7.81898 15.3003 7.81898 15.0716 8.04768L13.8492 9.27005Z",
    fill: "#32589F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66115 16.6815C9.64761 16.6799 9.63486 16.6799 9.62131 16.6799H9.23325V4.35495C9.23325 4.11989 9.04281 3.93024 8.80854 3.93024C8.57427 3.93024 8.38382 4.11989 8.38382 4.35495V18.8043V18.8051C8.38382 19.0394 8.19337 19.2298 7.9591 19.2298C7.72483 19.2298 7.53439 19.0402 7.53439 18.8051V16.7531C5.80761 17.032 4.68091 17.8169 4.68091 18.7883C4.68091 20.0091 6.48179 20.9302 8.86994 20.9302C11.2581 20.9302 13.059 20.0091 13.059 18.7883C13.059 17.7181 11.694 16.8719 9.66205 16.6823L9.66115 16.6815Z",
    fill: "#32589F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagicon);
export default __webpack_public_path__ + "static/media/flagicon.71d6bad131544bbacfd483decacd90cf.svg";
export { ForwardRef as ReactComponent };